import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
export var NotBrandNorRetailerMessage = function NotBrandNorRetailerMessage(_ref) {
  var visible = _ref.visible;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "RTbSpK",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous êtes une marque ou un commerçant, veuillez choisir l'une des options ci-dessus pour obtenir une réponse sous 24 heures. Si vous n'êtes pas une marque ni un commerçant, veuillez nous envoyer un e-mail à l'adresse external-requests@faire.com."
    }]
  }));
};